import type { ReactElement } from 'react'

import { ThemesListEntry } from './ThemesListEntry'
import { useTranslate } from '../../../utils/translate'

export function ThemesList({ themes }: Readonly<{ themes: Core.Theme[] }>): ReactElement {
  const t = useTranslate('interface', 'views.editorThemesView.themesList')

  return (
    <fieldset className="ep-theme-manager-themes-list-container">
      <legend className="visually-hidden">{t('accessibilityTitle')}</legend>
      <div className="ep-theme-manager-themes-list" role="list">
        {themes.map((theme) => (
          <ThemesListEntry key={theme.id} theme={theme} />
        ))}
      </div>
    </fieldset>
  )
}
